<template>
  <unicom-layout-cartao semFiltro>
    <unicom-linha class="linha-embaixo">
      <unicom-coluna sm="12" style="padding-bottom: 24px">
        <div class="titulo negrito cor-fonte fonte-primaria">
          Serviços Prestados
        </div>
      </unicom-coluna>
    </unicom-linha>

    <pronto-atendimento-componente
      v-if="objetoServicos['Pronto Atendimento'].ativo"
      :dadosServidorServicos="this.dadosServidorServ"
      :servico="objetoServicos['Pronto Atendimento']"
      @colher-payload="prepararPayloadServicos"
      @switch="switchHandler"
      @error="errorHandler"
    ></pronto-atendimento-componente>

    <laboratorio-componente
      v-if="objetoServicos['Laboratório'].ativo"
      :dadosServidor="this.dadosServidorServ"
      :servico="objetoServicos['Laboratório']"
      @colher-payload="prepararPayloadServicos"
      @switch="switchHandler"
      @error="errorHandler"
    ></laboratorio-componente>

    <centro-diagnostico-componente
      v-if="objetoServicos['Centro de Diagnóstico'].ativo"
      :dadosServidor="this.dadosServidorServ"
      :servico="objetoServicos['Centro de Diagnóstico']"
      @colher-payload="prepararPayloadServicos"
      @switch="switchHandler"
      @error="errorHandler"
    ></centro-diagnostico-componente>

    <posto-coleta-componente
      v-if="objetoServicos['Posto de Coleta'].ativo"
      :dadosServidor="this.dadosServidorServ"
      :servico="objetoServicos['Posto de Coleta']"
      @colher-payload="prepararPayloadServicos"
      @switch="switchHandler"
      @error="errorHandler"
    ></posto-coleta-componente>
  </unicom-layout-cartao>
</template>

<script>
import ServicosMixin from "@/views/RecursosPropriosQuestionarios/CentroDiagnostico/componentes/CartaoInformacoesServicos/ServicosMixin";
import LaboratorioComponente from "./components/LaboratorioComponente.vue";
import CentroDiagnosticoComponente from "./components/CentroDiagnosticoComponente.vue";
import ProntoAtendimentoComponente from "./components/ProntoAtendimentoComponente.vue";
import PostoColetaComponente from "./components/PostoColetaComponente.vue";
import MixinValidacoes from "@/views/RecursosPropriosQuestionarios/shared/mixins/validation/MixinValidacoesQuestionario";

export default {
  mixins: [ServicosMixin, MixinValidacoes],
  components: {
    LaboratorioComponente,
    CentroDiagnosticoComponente,
    ProntoAtendimentoComponente,
    PostoColetaComponente
  },
  data() {
    return {};
  },
  methods: {
    prepararPayloadServicos(payloadDoComponente) {
      if (!payloadDoComponente) return;

      this.objetoServicos[payloadDoComponente.tipoServico].payload = {
        ...payloadDoComponente
      };

      if (payloadDoComponente.clickSwitch) {
        this.objetoServicos[payloadDoComponente.tipoServico].preenchido = true;
      }

      this.preparaDadosServicos();
    },
    switchHandler(payload) {
      this.objetoServicos[payload.tipoServico].preenchido = payload.clickSwitch;

      if (!payload.clickSwitch) {
        this.payloadServicos = this.payloadServicos.filter(
          servico => servico.tipoServico.tipoServico !== payload.tipoServico
        );
        this.payloadEspecialidades = this.payloadEspecialidades.filter(
          espe => espe.tipoServico.tipoServico !== payload.tipoServico
        );
        this.payloadAbrancencias = this.payloadAbrancencias.filter(
          abran => abran.tipoServico.tipoServico !== payload.tipoServico
        );
      }

      this.$emit("payload-atualizado", {
        servicos: [...this.payloadServicos],
        especialidades: [...this.payloadEspecialidades],
        abrangencias: this.payloadAbrancencias
      });
    }
  }
};
</script>

<style scoped>
.linha-embaixo {
  padding-bottom: 24px;
  border-bottom: 1px solid #ebebeb;
  margin-bottom: 24px;
}
</style>
